import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';

import { styles } from '../styles';

const PlanTypeInput = ({ error, field, isRenewForm, plans }) => {
	return (
		<FormControl variant="filled" error={Boolean(error)} sx={styles.field}>
			<InputLabel id="select-plan-type" required>
				{isRenewForm ? 'Select Renewal Member Type' : 'Plan Type'}
			</InputLabel>
			<Select labelId="select-plan-type" id="demo-simple-select-filled" {...field}>
				{plans.map(plan => {
					return (
						<MenuItem key={plan.id} value={plan.id}>
							{plan.name}
						</MenuItem>
					);
				})}
			</Select>
			{Boolean(error?.message) && <Box sx={styles.error}>{error.message}</Box>}
		</FormControl>
	);
};

export default PlanTypeInput;
